import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import styled from 'styled-components';
import Title1 from '../../../components/Typography/Title1';
import { PrimaryButton } from '../../../components/Buttons';
import {
  showSelectPaymentMethodForm,
  setSelectedPaymentMethod,
  showPaymentMethodSelectionForm,
} from '../../../modules/PaymentMethods/paymentMethodsActions';
import ControlledRadio from '../../../components/Form/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
  PICKUP,
  DELIVERY,
  DROPOFF,
} from '../../OrderSetting/orderSettingTypes';

const Transition = (props) => <Slide direction='up' {...props} />;

const Wrapper = styled.div`
  display: grid;
  grid-gap: 37px;
  align-items: center;
  justify-self: center;
  margin: 20px;
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const PaymentTypeSelectionDiv = styled(RadioGroup)``;

const HrLine = styled.hr`
  background: #ebebeb;
  margin-bottom: 0;
`;
const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 14px;
`;

const ContinueButton = styled(PrimaryButton)`
  width: 70%;
  margin: auto;
  height: 56px;

  @media screen and (max-width: 767px) {
    width: 100%;
    margin: auto;
    min-width: auto;
  }
`;

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paper: {
    margin: 0,
    width: '100%',
    boxShadow: 'none',
  },
  paper1: {
    margin: 0,
    width: '100%',
  },
  labelPlacementStart: {
    marginLeft: '0',
  },
});

let SelectPaymentMethodFormContainer = ({
  classes,
  paymentMethodsReducer,
  showSelectPaymentMethodForm,
  setSelectedPaymentMethod,
  showPaymentMethodSelectionForm,
  orderSettingReducer,
}) => {
  const { selectPaymentMethodFormIsVisible } = paymentMethodsReducer;

  const [paymentMethod, setPaymentMethod] = useState(null);

  const paymentTypeChangeHandler = (e) => {
    setPaymentMethod(e.target.value);
  };

  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
  } = orderSettingReducer;

  const isPayOnArrival =
    interOrderType === PICKUP && interPickUpDetails
      ? interPickUpDetails.accepted_order_types_config?.pickup
          .is_loyalty_only_enabled
      : interOrderType === DELIVERY &&
        interDeliveryDetails &&
        interDeliveryDetails.deliveryBusiness
      ? interDeliveryDetails.deliveryBusiness.accepted_order_types_config
          ?.delivery.is_loyalty_only_enabled
      : interOrderType === DROPOFF && interDropOffDetails
      ? interDropOffDetails.accepted_order_types_config?.drop_off
          .is_loyalty_only_enabled
      : null;

  return (
    <Dialog
      id='SelectPaymentMethodFormContainer-Dialog'
      open={selectPaymentMethodFormIsVisible}
      onClose={() => showSelectPaymentMethodForm(false)}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      TransitionComponent={Transition}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      classes={classes.root}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
      PaperProps={{
        classes: { root: classes.paper1 },
      }}
      aria-labelledby='create-gift-card'
      overlayStyle={{ backgroundColor: 'transparent' }}
      scroll='body'
    >
      <Wrapper>
        <TitleWrapper>
          <Title1 style={{ fontWeight: '600' }}>Choose Payment Method</Title1>
          <Cancel
            onClick={(e) => {
              e.stopPropagation();
              showSelectPaymentMethodForm(false);
            }}
          >
            <i className='fal fa-times' />
          </Cancel>
        </TitleWrapper>
        <PaymentTypeSelectionDiv
          name='paymentType'
          onChange={paymentTypeChangeHandler}
          value={paymentMethod}
        >
          <div>
            <FormControlLabel
              labelPlacement='start'
              label='Pay Now'
              value='payNow'
              control={<ControlledRadio />}
              classes={classes}
            />
            <HrLine />
          </div>
          {isPayOnArrival && (
            <div>
              <FormControlLabel
                labelPlacement='start'
                label='Pay on Arrival'
                value='poa'
                control={<ControlledRadio />}
                classes={classes}
              />
              <HrLine />
            </div>
          )}
        </PaymentTypeSelectionDiv>

        <ButtonWrapper>
          <ContinueButton
            disabled={!paymentMethod}
            onClick={() => {
              setSelectedPaymentMethod(paymentMethod);
              showSelectPaymentMethodForm(false);
              if (paymentMethod === 'payNow') {
                showPaymentMethodSelectionForm(true);
              }
            }}
          >
            Continue
          </ContinueButton>
        </ButtonWrapper>
      </Wrapper>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  paymentMethodsReducer: state.paymentMethodsReducer,
  orderSettingReducer: state.orderSettingReducer,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    showSelectPaymentMethodForm,
    setSelectedPaymentMethod,
    showPaymentMethodSelectionForm,
  })(SelectPaymentMethodFormContainer)
);
